import { IconPlus } from "@tabler/icons-react";
import { useMemo } from "react";
import { useSetActionButtons } from "../../services/ActionButtonsContext";
import { openLanguageModal } from "./LanguageModal";

import { useGetAllAvailableLanguages } from "../../api/languages";
import { useSearchParams } from "react-router-dom";
import LanguagesDatatable from "./LanguagesDatatable";

const LanguagesTab = () => {
  const [searchParams, setSearchParams] = useSearchParams();

  const pageParam = searchParams.get("page");
  const limitParam = searchParams.get("limit");

  const page = Math.max(1, parseInt(pageParam) || 1);
  const limit = Math.max(1, Math.min(100, parseInt(limitParam) || 10));

  const { data: languages, isPending } = useGetAllAvailableLanguages({
    page,
    limit,
  });

  const actions = useMemo(
    () => [
      {
        label: "Add",
        onClick: () => openLanguageModal({ action: "add" }),
        icon: <IconPlus />,
      },
    ],
    []
  );

  useSetActionButtons(actions);

  const handlePageChange = (newPage) => {
    setSearchParams((params) => {
      params.set("page", newPage.toString());
      return params;
    });
  };
  return (
    <>
      <LanguagesDatatable
        data={languages?.data}
        pagination={languages?.pagination}
        page={page}
        onPageChange={handlePageChange}
        totalRecords={languages?.pagination?.total}
        recordsPerPage={limit}
        fetching={isPending}
      />
    </>
  );
};

export default LanguagesTab;
